import moment from 'moment-timezone';
import MasterSchema from './MasterSchema';

function toSnakeCase(key) {
  return key.split(/(?=[A-Z])/).join('_').toLowerCase();
}

function getProperties(name) {
  const defaultProperties = MasterSchema.getSchema(name).properties;
  const properties = {};

  Object.keys(defaultProperties).forEach((key) => {
    const property = this[key];
    if (property instanceof Array) {
      properties[key] = property.map((value) => value.getProperties());
    } else if (property instanceof Object) {
      properties[key] = property.getProperties();
    } else if (property !== null) {
      properties[key] = this[key];
    }
  });
  return properties;
}

export default class ModelFactory {
  static getConstants(name) {
    const schema = MasterSchema.getSchema(name);
    return schema.constants;
  }

  static create(name, values = {}, isConvertTimezone = true) {
    const schema = MasterSchema.getSchema(name);
    const model = { ...schema.properties };

    if (values instanceof Object && !(values instanceof Array)) {
      Object.keys(values).forEach((key) => {
        const systemTimeColumns = ['start_at', 'end_at', 'sent_at', 'finished_at', 'last_tested_at', 'expires_at', 'created_at', 'updated_at'];
        if (Object.prototype.hasOwnProperty.call(schema.properties, key)) {
          model[key] = values[key];
          if (typeof window.app !== 'undefined') {
            const store = window.app.config.globalProperties.$store;
            const timezone = store.state.loginUser?.timezone;
            const userTimezone = timezone ? timezone.code : 'UTC';
            if (systemTimeColumns.includes(key) && values[key] && isConvertTimezone) {
              model[key] = moment.utc(values[key]).tz(userTimezone).format('YYYY/M/D HH:mm:ss');
            }
          }
        }
        if (schema.appends.indexOf(key) > -1) {
          model[key] = values[key];
        }
      });
    }

    model.getProperties = getProperties.bind(model, name);
    return Object.assign(model, ModelFactory.getRelations(schema.relations, values));
  }

  static getRelations(schemas, values = {}) {
    const relations = {};
    Object.keys(schemas).forEach((key) => {
      const relation = values[toSnakeCase(key)];
      if (relation instanceof Array) {
        relations[key] = relation.map((value) => ModelFactory.create(schemas[key], value));
      } else if (relation instanceof Object && relation !== null) {
        relations[key] = ModelFactory.create(schemas[key], relation);
      } else {
        relations[key] = null;
      }
    });
    return relations;
  }
}
